// src/pages/widgets/WidgetShellCard.jsx

import styles from './Widget.module.css';

export default function WidgetShellCard({ title, children, className, headerRight }) {
    return (
        <section className={`${styles.card} ${className ?? ''}`}>
            <header className={styles.card__header}>
                <div className={styles.cardHeaderLeft}>{title}</div>
                {headerRight && <div className={styles.cardHeaderRight}>{headerRight}</div>}
            </header>
            <div className={styles.card__body}>{children}</div>
        </section>
    );
}
